import type { Pinia } from "pinia";
import { useAuthTokenStore } from "./useAuthTokenStore";
import { useNewAppointmentStore } from "./useNewAppointmentStore";
import { useOffcanvasStore } from "./useOffcanvasStore";
import { useRegisterStore } from "./useRegisterStore";
import { useSessionStore } from "./useSessionStore";

// Migração única do blob da antiga store única (useMainStore, apagada na X02) (VUE_APP_API_STATE_KEY) para as
// stores por assunto. Só preenche o que as stores novas ainda não têm e apaga a
// chave antiga em seguida, para uma sessão encerrada não "ressuscitar" depois.
// Pode ser removida quando não houver mais usuários com a versão anterior.
export function migrateLegacyState(pinia: Pinia) {
  const legacyKey = process.env.VUE_APP_API_STATE_KEY as string;
  const raw = localStorage.getItem(legacyKey);
  if (!raw) return;

  try {
    const legacy = JSON.parse(raw);
    const session = useSessionStore(pinia);
    const authToken = useAuthTokenStore(pinia);
    const newAppointment = useNewAppointmentStore(pinia);
    const register = useRegisterStore(pinia);

    if (!session.session && legacy.session) session.save(legacy.session);
    if (!authToken.token && legacy.access_token) authToken.save(legacy.access_token);
    if (!newAppointment.data && legacy.new_appointment_info) newAppointment.save(legacy.new_appointment_info);
    if (!register.data && legacy.register_info) register.save(legacy.register_info);
    // offcanvas não é migrado de propósito: abrir o app com o painel fechado é o esperado
    useOffcanvasStore(pinia).clear();
  } catch (e) {
    console.error("Falha ao migrar o estado antigo", e);
  }
  localStorage.removeItem(legacyKey);
}
